import { styled } from '@mui/material';
import { getToken } from '@workiva/unify-tokens';

import { Stack } from 'src/components/Stack';
import fileUploaderClasses from 'src/components/FileUploader/fileUploaderClasses';
import { fileUploaderMinWidth } from 'src/components/FileUploader/slots/FileUploaderDropzone';

export const FileUploaderFieldsetRoot = styled(Stack, {
  name: 'UnifyFileUploader',
  slot: 'Fieldset',
  overridesResolver: (_, styles) => {
    return [
      styles.fieldset,
      {
        [`.${fileUploaderClasses.fileList}`]: styles.fileList,
      },
      {
        [`&.${fileUploaderClasses.disabled}`]: styles.disabled,
      },
      // NOTE: the dropZone slot has its own styled root where overrides are applied for its slots / stateful classes
    ];
  },
})(() => {
  return {
    minWidth: fileUploaderMinWidth,

    [`&.${fileUploaderClasses.disabled}`]: {
      color: getToken('Core/Text/text-disabled'),

      [`.${fileUploaderClasses.legend}`]: {
        // Necessary to override the web-skin legend element color
        color: getToken('Core/Text/text-disabled'),
      },
    },
  };
});

export default FileUploaderFieldsetRoot;
